import React from "react";

import { Box } from "@mui/material";
import { RoleComponentGuard } from "components";
import { AccessDenied } from "components/Access-denied/AccessDenied";
import { ReportGenerator as ReportGeneratorCanvas } from "components/Report-generator";
import { useNavigate } from "hooks";
import { usePickUserPermissions } from "store";
import { UserPermissionType } from "store/types";

import { RoleName } from "../../constants";

export const ReportGenerator: React.FC = () => {
  const externalReport = usePickUserPermissions("external_reports");
  const noAccessPermission = externalReport && externalReport === UserPermissionType.NO_ACCESS;
  const navigate = useNavigate();

  return (
    <RoleComponentGuard
      availableRoles={[RoleName.Admin, RoleName.Analyst, RoleName.TeamViewer]}
      hideChild={noAccessPermission}
      RenderInstead={<AccessDenied redirectClick={() => navigate({ route: "main" })} title="Back home" />}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflow: "hidden",
          padding: 0,
          margin: 0
        }}
      >
        <ReportGeneratorCanvas />
      </Box>
    </RoleComponentGuard>
  );
};
